import TextField from "@mui/material/TextField";
import { useContext, useEffect, useRef } from "react";
import { useController } from "react-hook-form";
import { FormContext } from "components/shared/Form";

const GooglePlacesAutoComplete = ({ name, type, ...props }) => {
  const {
    form: { control },
  } = useContext(FormContext);

  const { field, fieldState } = useController({
    control: control,
    name: name,
  });
  const addressFields = {
    street_number: "",
    route: "",
    locality: "",
    postal_code: "",
    administrative_area_level_1: "",
    country_str: "",
  };

  const inputRef = useRef(null);
  const autoCompleteRef = useRef();
  const currentValue = useRef(field.value?.formatted_address || "");
  const idRef = useRef(field.value?.id);

  useEffect(() => {
    inputRef.current.value = currentValue.current;
    autoCompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        field: ["address_components", "formatted_address"],
      },
    );
    autoCompleteRef.current.addListener("place_changed", function () {
      const place = autoCompleteRef.current.getPlace();
      if (!place || !place.address_components) return field.onChange(null);
      const dictionary = Object.fromEntries(
        place.address_components.flatMap((component) => {
          return component.types.map((componentType) => [
            componentType,
            component.long_name,
          ]);
        }),
      );
      dictionary["country_str"] = dictionary.country;
      delete dictionary.country;
      dictionary["formatted_address"] = place.formatted_address;
      dictionary["address_components"] = place.address_components;
      dictionary["id"] = idRef.current;
      inputRef.current.value = currentValue.current = place.formatted_address;
      field.onChange({ ...addressFields, ...dictionary });
    });
  }, []);

  return (
    <TextField
      inputRef={inputRef}
      onChange={(value) => {
        if (inputRef.current.value == "") {
          currentValue.current = "";
          field.onChange(null);
        }
      }}
      onBlur={() => {
        inputRef.current.value = currentValue.current;
        field.onBlur();
      }}
      shrink={currentValue.current}
      placeholder="Headquarter address"
      helperText={fieldState.error?.message}
      error={fieldState.invalid}
      variant="standard"
      {...props}
    />
  );
};

export default GooglePlacesAutoComplete;
